<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all FreeCreation">
    <div class="pc_all_content">
      <!-- 导航部分 -->
      <div
        class="FreeCreationNav animate__animated animate__fadeInDown"
        style="animation-delay: 0.2s"
      >
        <div class="FreeCreationNav_btn">
          <router-link to="/ailogo/FreeCreation/FreeCreation" class="FreeCreationNav_list font20 active">
            <span class="iconfont icon-chuangzuozhezhongxin"></span>自由创作
          </router-link>
          <router-link to="/ailogo/LetterLogo/LetterLogo" class="FreeCreationNav_list font20">
            <span class="iconfont icon-fa-buysellads"></span>字母LOGO
          </router-link>
          <router-link to="/ailogo/SameCreation/SameCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-AItongkuan"></span>同款创作
          </router-link>
        </div>
      </div>

      <!-- 风格和配色选择部分 -->
      <div class="StyleColor">
        <div
          class="StyleColor_title font20 animate__animated animate__fadeInDown"
          style="animation-delay: 0.4s"
        >
          选择您喜欢的风格和配色
        </div>
        <!-- 行业选择列表 -->
        <div class="SelectIndustry">
          <!-- 你的模板代码 -->
          <div
            class="SelectIndustry_list font20 animate__animated animate__fadeInDown"
            :style="{ animationDelay: industry.animationDelay + 's' }"
            v-for="(industry, index) in industries"
            :key="'industry-' + index"
            :class="{ active: selectedIndustry == industry.id }"
            @click="selectIndustry(industry.id)"
          >
            <div class="SelectIndustry_list_left font20">
              <div class="list_left_icon" :style="{ background: industry.background }">
                <!-- 动态加载图片 -->
                <img :alt="industry.name" :src="industry.image" />
              </div>
              {{ industry.name }}
            </div>
            <div class="SelectIndustry_list_right"></div>
          </div>
        </div>

        <!-- 配色选择列表 -->
        <div class="StyleColor_color">
          <div
            class="StyleColor_color_list animate__animated animate__fadeInDown"
            style="animation-delay: 0.3s"
            v-for="(colorList, index) in colorLists"
            :key="'colorList-' + index"
            :class="{ active: selectedColorList == colorList.id }"
            @click="selectColorList(colorList.id)"
          >
            <div class="color_list_top">
              <div class="list_top_li" v-for="n in 1" :key="'color-' + n"></div>
            </div>
            <div class="color_list_title font16">{{ colorList.title }}</div>
          </div>
        </div>

        <!-- 其他颜色输入部分 -->
        <div
          class="StyleColor_bottomcolor animate__animated animate__fadeInDown"
          style="animation-delay: 0.6s"
          :class="{ active: otherColorInput }"
        >
          <div class="StyleColor_bottomcolor_left font18"><span></span>其他：</div>
          <div class="StyleColor_bottomcolor_right">
            <input
              type="text"
              placeholder="请输入您喜欢的颜色（例如：棕色）"
              class="font20"
              v-model="otherColorInput"
              @input="handleInput"
            />
          </div>
        </div>
      </div>

      <!-- 按钮部分 -->
      <div class="Btn animate__animated animate__fadeInDown" style="animation-delay: 0.6s">
        <div class="Btn_prev font20" @click="goBack">
          <span class="iconfont icon-xiangyou"></span>上一步
        </div>
        <div class="Btn_next font20" :class="{ active: isBtnNextActive }" @click="goToFreeCreation">
          <div class="form_btn_po">继续<span class="iconfont icon-xiangyou"></span></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      selectedIndustry: null, // 当前选中的行业索引
      selectedColorList: null, // 当前选中的配色列表索引
      otherColorInput: '', // 其他颜色输入内容
      industries: [],
      colorLists: [],
    }
  },
  components: {
    Header
  },
  created() {
    this.getStyles(); // 在组件创建时调用获取风格的方法
    this.getColorLists(); // 在组件创建时调用获取配色列表的方法
    // 从 localStorage 加载数据
    this.loadFromLocalStorage();
  },
  methods: {
    ...mapActions(['updateSelectedStyleId', 'updateSelectedColorId', 'updateOtherColor']),
    //获取风格
    async getStyles() {
      try {
        const res = await this.axios.get(`api/LogoInfo/styleList`); // 假设你的接口地址是这个
        if (res.code === 1) {
          this.industries = res.result.map((style, index) => ({
            id: style.id,
            name: style.name_cn, // 从 API 获取风格名称
            background: style.color || '#ffe4bd', // 根据实际数据设置背景颜色
            image: style.icon, // 根据实际数据动态设置图片
            animationDelay: (0.1 + index * 0.1) // 递增逻辑
          }));
          console.log("处理后的风格数据:", this.industries);
        } else {
          console.error("接口返回错误:", res);
        }
      } catch (error) {
        console.error("获取风格时出错:", error);
      }
    },
    async getColorLists() {
      try {
        const res = await this.axios.get(`api/LogoInfo/colorList`); // 请求配色列表的接口
        if (res.code === 1) {
          this.colorLists = res.result.map(color => ({
            id: color.id,
            title: color.name_cn
          }));
          console.log("处理后的配色列表数据:", this.colorLists);
        } else {
          console.error("接口返回错误:", res);
        }
      } catch (error) {
        console.error("获取配色列表时出错:", error);
      }
    },
    // 选择行业
    selectIndustry(index) {
      this.selectedIndustry = index;
      const selectedStyleId = index;
      this.updateSelectedStyleId(selectedStyleId); // 存储到 Vuex

      //存储到 localStorage
      localStorage.setItem('logoSelectedStyleId', selectedStyleId);
    },
    // 选择配色列表
    selectColorList(index) {
      // 当输入其他颜色时，清除配色列表的选中
      /*if (this.otherColorInput.trim() !== '') {
        this.otherColorInput = ''
      }*/
      // 选择颜色时清空输入框
      this.otherColorInput = '';
      this.updateOtherColor(''); // 同时清空 Vuex 中的其他颜色
      //清空 localStorage 中的其他颜色
      localStorage.setItem('logoOtherColor', '');

      this.selectedColorList = index;
      const selectedColorId = index;
      this.updateSelectedColorId(selectedColorId); // 存储到 Vuex
      //存储到 localStorage
      localStorage.setItem('logoSelectedColorId', selectedColorId);

    },
    // 处理其他颜色输入
    handleInput() {
      this.updateOtherColor(this.otherColorInput); // 更新 Vuex 中的其他颜色
      //更新 localStorage 中的其他颜色
      localStorage.setItem('logoOtherColor', this.otherColorInput);
      if (this.otherColorInput.trim() !== '') {
        // 输入内容时，取消配色列表的选中
        this.selectedColorList = null;
        this.updateSelectedColorId(0); // 清空 Vuex 中的 selectedColorId
        //清空 localStorage 中的 selectedColorId
        localStorage.setItem('logoSelectedColorId', 0);
      }
    },
    goToFreeCreation() {
      if (this.isBtnNextActive) {
        this.$emit('increase-progress')
        this.$router.push('/ailogo/FreeCreation/FreeCreationKeyword')
      }
    },
    goBack() {
      this.$emit('decrease-progress')
      this.$router.back() // 或者使用 this.$router.go(-1) 返回前一个页面
    },
    // 从 localStorage 加载数据
    loadFromLocalStorage() {
      // 从 localStorage 加载选中的风格
      const selectedStyleId = localStorage.getItem('logoSelectedStyleId');
      console.log("从 localStorage 加载选中的风格:", selectedStyleId);
      if (selectedStyleId) {
        this.selectedIndustry = selectedStyleId;
      }
      // 从 localStorage 加载选中的配色列表
      const selectedColorId = localStorage.getItem('logoSelectedColorId');
      if (selectedColorId) {
        this.selectedColorList = selectedColorId;
      }
      // 从 localStorage 加载其他颜色
      const otherColor = localStorage.getItem('logoOtherColor');
      if (otherColor) {
        this.otherColorInput = otherColor;
      }
    }
  },
  computed: {
    // 计算“继续”按钮是否激活
    isBtnNextActive() {
      return (
        this.selectedIndustry !== null ||
        this.selectedColorList !== null ||
        this.otherColorInput.trim() !== ''
      )
    }
  }
}
</script>


<style>
@import "FreeCreation.css";
</style>
